import './SubmissionTable.css'
import React, {useContext, useState} from 'react'
import { studentSubmissions, test } from '../../../../Status'
import AssigningScores from '../../../Modals/AssigningScores/AssigningScores'
import { useNavigate } from 'react-router-dom'
import { AuthContext } from '../../../../context/authContext'

const SubmissionTable = ({AllSubmissions}) => {
  const {user}=useContext(AuthContext)
  const [Search, setSearch] = useState("")
        const [AssignScore, setAssignScore] = useState(0)
        const navigate=useNavigate()
    return (
      <div className="table-container Scrollable-table">
        
          <table className="archive-table ">
            <thead>
              <tr>
                <th>Ref*</th>
                <th>Student</th>
                <th>Posted</th>
                <th>Corrector</th>
                <th>Status</th>
                <th>Done</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
  
              {AllSubmissions?.map((submission,index)=>(
                <tr key={index} style={{backgroundColor :submission?.discussion?.length > 0 &&
      submission.discussion[submission.discussion.length - 1]?.poster?.role.trim().toLowerCase() === "student" &&
      submission?.result?.trim().toLowerCase() === "in process" && submission?.coordinator?._id === user._id 
        ? "#efe93375"
        : null,}}>
                  <td>{submission.problemRef}</td>
                  <td>{submission.student.name}</td>
                  <td>18/08/2025</td>
                  <td>{submission.coordinator.name}</td>
                  <td style={{color : submission.result.toLowerCase() === "on hold"
          ? "gray" : submission.result.toLowerCase() === "in process"
          ? "#EDAB18"
          : submission.result.toLowerCase() === "correct"
          ? "green"
          : "red",}}>{submission.result}</td>
                  <td>-</td>
                  <td><button onClick={()=>navigate(`/Submission/${submission.problemRef}/${submission.student._id}`)}>See More</button></td>
                </tr>
              ))}
            </tbody>
          </table>
          {AssignScore!=0?<AssigningScores setAssignScore={setAssignScore} Student={studentSubmissions.find(submission => submission.Number===AssignScore)}/>: null}
     
      </div>
  )
}

export default SubmissionTable
